import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../Header';
import logo_img from './../assets/images/notfound.jpg';
class Unauthorized extends Component {
    constructor(props){
        super(props);
        this.state = {
            
        }
    }
    back() {
        window.location.href = '/login/';
    }
    render(){
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        //console.log(this.props.match.params.todoId);
        return(
            <div >
            <Header brecum_name="" brecum_page=""/>
            <div class="right_col">
            <div class="intranet_body">
            <img src={logo_img}/>
            </div>
            </div>
            </div>
            
            
        )
    }
    componentDidMount() {
		if (!localStorage.getItem('userLogin')) {
			this.setState({ redirect: true });
}
    }
}

export default Unauthorized;



// WEBPACK FOOTER //
// ./src/components/Unauthorized.js